import { useQueryClient } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "./features/auth";
import { appInsights } from "./features/instruments";
import type { AppRouter } from "./Router";

// Splittet opp i egen komponent for å unngå at hele appen rendres, og at HMR fungerer korrekt
export const InnerApp = ({ router }: { router: AppRouter }) => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  useEffect(() => {
    // @tanstack/react-router: subscribe to router changes
    const unsubscribe = router?.subscribe?.("onResolved", (_: unknown) => {
      appInsights.trackPageView({
        uri: window.location.pathname + window.location.search,
        properties: { portal: "kundeportal" },
      });
    });

    // fallback: track initial view
    appInsights.trackPageView({
      uri: window.location.pathname + window.location.search,
      properties: { portal: "kundeportal" },
    });

    return () => unsubscribe?.();
  }, [router]);
  return <RouterProvider router={router} context={{ auth, queryClient }} />;
};
